import { Controller } from '@hotwired/stimulus';
import { visit } from '@hotwired/turbo';
import { confirmDialog } from '../js/confirm_dialog';

// Garde contre la perte de saisie, posée dans le formulaire (barre
// d'actions) : formulaire modifié (input, change) ou réaffiché refusé
// (alerte d'erreurs visible), quitter la page par Turbo demande
// confirmation, fermer ou recharger l'onglet laisse le navigateur demander ;
// pendant l'envoi la garde est suspendue, un envoi réussi et le bouton
// Annuler (choix explicite, action discard) la lèvent.
export default class extends Controller {
    connect() {
        this.form = this.element.closest('form');
        if (!this.form) return;

        this.dirty = [...this.form.querySelectorAll('[role="alert"]')].some((alert) => !alert.hidden && alert.textContent.trim() !== '');
        this.submitting = false;
        this.markDirty = () => { this.dirty = true; };
        this.release = () => { this.submitting = true; };
        this.submitEnd = (event) => {
            this.submitting = false;
            if (event.detail.success) this.dirty = false;
        };
        this.beforeVisit = (event) => this.guardVisit(event);
        this.beforeUnload = (event) => {
            if (!this.dirty || this.submitting) return;
            event.preventDefault();
            event.returnValue = '';
        };
        this.form.addEventListener('input', this.markDirty);
        this.form.addEventListener('change', this.markDirty);
        this.form.addEventListener('submit', this.release);
        this.form.addEventListener('turbo:submit-end', this.submitEnd);
        document.addEventListener('turbo:before-visit', this.beforeVisit);
        window.addEventListener('beforeunload', this.beforeUnload);
    }

    disconnect() {
        if (!this.form) return;

        this.form.removeEventListener('input', this.markDirty);
        this.form.removeEventListener('change', this.markDirty);
        this.form.removeEventListener('submit', this.release);
        this.form.removeEventListener('turbo:submit-end', this.submitEnd);
        document.removeEventListener('turbo:before-visit', this.beforeVisit);
        window.removeEventListener('beforeunload', this.beforeUnload);
    }

    discard() {
        this.dirty = false;
    }

    async guardVisit(event) {
        if (!this.dirty || this.submitting) return;

        event.preventDefault();
        const url = event.detail.url;
        const holder = document.createElement('div');
        holder.title = 'Modifications non enregistrées';
        Object.assign(holder.dataset, { commit: 'Quitter sans enregistrer', commitClass: 'danger' });
        if (await confirmDialog('Les modifications de ce formulaire seront perdues.', holder)) {
            this.dirty = false;
            visit(url);
        }
    }
}
